/** Nombre formal de la aplicación (emails, documentación, metadatos extensos). */
export const APP_NAME = 'Sistema de Recursos Humanos';

/** Nombre corto para UI (login, chips, pies de página, pestaña del navegador). */
export const APP_SHORT_NAME = 'RRHH Salud Chaco';

export const APP_ORGANISM = 'Ministerio de Salud · Provincia del Chaco';

export const APP_FOOTER = `${APP_NAME} - Ministerio de Salud del Chaco`;

export const APP_UI_TITLE = `${APP_SHORT_NAME} - Ministerio de Salud`;

export const APP_UI_DESCRIPTION = `${APP_SHORT_NAME} - Ministerio de Salud de la Provincia del Chaco`;
